import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Halogen$dData$dOrdBox from "../Halogen.Data.OrdBox/index.js";
const ordTuple = /* #__PURE__ */ (() => {
  const eqTuple2 = {eq: x => y => x._1 === y._1 && x._2._1(x._2._3)(y._2._3)};
  return {
    compare: x => y => {
      const v = Data$dOrd.ordString.compare(x._1)(y._1);
      if (v === "LT") { return Data$dOrdering.LT; }
      if (v === "GT") { return Data$dOrdering.GT; }
      return x._2._2(x._2._3)(y._2._3);
    },
    Eq0: () => eqTuple2
  };
})();
const pop1 = /* #__PURE__ */ Data$dMap$dInternal.pop(ordTuple);
const lookup1 = k => {
  const go = go$a0$copy => {
    let go$a0 = go$a0$copy, go$c = true, go$r;
    while (go$c) {
      const v = go$a0;
      if (v.tag === "Leaf") {
        go$c = false;
        go$r = Data$dMaybe.Nothing;
        continue;
      }
      if (v.tag === "Node") {
        const v1 = ordTuple.compare(k)(v._3);
        if (v1 === "LT") {
          go$a0 = v._5;
          continue;
        }
        if (v1 === "GT") {
          go$a0 = v._6;
          continue;
        }
        if (v1 === "EQ") {
          go$c = false;
          go$r = Data$dMaybe.$Maybe("Just", v._4);
          continue;
        }
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go;
};
const slots = () => dictIsSymbol => dictOrd => {
  const foldSubmap1 = Data$dMap$dInternal.foldSubmap(ordTuple)((() => {
    const $0 = Data$dMap$dInternal.plusMap(dictOrd);
    const $1 = $0.Alt0();
    const semigroupAlternate1 = {append: v => v1 => $1.alt(v)(v1)};
    return {mempty: $0.empty, Semigroup0: () => semigroupAlternate1};
  })());
  return sym => v => {
    const key = dictIsSymbol.reflectSymbol(sym);
    return foldSubmap1(Data$dMaybe.Nothing)(Data$dMaybe.Nothing)(v1 => val => {
      if (key === v1._1) { return Data$dMap$dInternal.$$$Map("Node", 1, 1, v1._2._3, val, Data$dMap$dInternal.Leaf, Data$dMap$dInternal.Leaf); }
      return Data$dMap$dInternal.Leaf;
    })(v);
  };
};
const pop = () => dictIsSymbol => dictOrd => {
  const mkOrdBox = Halogen$dData$dOrdBox.OrdBox(dictOrd.Eq0().eq)(dictOrd.compare);
  return sym => key => v => pop1(Data$dTuple.$Tuple(dictIsSymbol.reflectSymbol(sym), mkOrdBox(key)))(v);
};
const lookup = () => dictIsSymbol => dictOrd => {
  const mkOrdBox = Halogen$dData$dOrdBox.OrdBox(dictOrd.Eq0().eq)(dictOrd.compare);
  return sym => key => v => lookup1(Data$dTuple.$Tuple(dictIsSymbol.reflectSymbol(sym), mkOrdBox(key)))(v);
};
const insert = () => dictIsSymbol => dictOrd => {
  const mkOrdBox = Halogen$dData$dOrdBox.OrdBox(dictOrd.Eq0().eq)(dictOrd.compare);
  return sym => key => val => v => Data$dMap$dInternal.insert(ordTuple)(Data$dTuple.$Tuple(dictIsSymbol.reflectSymbol(sym), mkOrdBox(key)))(val)(v);
};
const foreachSlot = dictApplicative => {
  const traverse_ = Data$dFoldable.traverse_(dictApplicative)(Data$dMap$dInternal.foldableMap);
  return v => k => traverse_(x => k(x))(v);
};
const empty = Data$dMap$dInternal.Leaf;
export {empty, foreachSlot, insert, lookup, lookup1, ordTuple, pop, pop1, slots};
